import { Validators } from "@angular/forms"
import { LayerType, overlayBlur, sharedForms } from "../layer.model"
import { FormType, OverlayProperties, Properties, RoadProperties } from "../properties.model"
import { generateRoadOptions } from "../../../services/image-data.utils"

export const roadForm: Properties = {
  propertyType: LayerType.Buildings,
  label: 'Building Layer',
  forms:
    sharedForms.concat([
    {
      id: RoadProperties.RoadGroup,
      label: 'Road Group',
      type: FormType.Multiselect,
      hint: "These are defined in the RenderSettings ModuleScript within Roblox Studio.",
      placeholder: 'Road Groups',
    },
    {
      id: RoadProperties.RoadColor,
      label: 'Fill Color',
      type: FormType.Color,
      placeholder: "#Hex Color",
      defaultValue: '#FFFFFF',
      validators: [Validators.required, Validators.min(1)],
    },
    {
      id: RoadProperties.RoadColorOpacity,
      label: 'Fill Opacity',
      type: FormType.SliderNumber,
      defaultValue: 1,
      hint: "Modify the opacity of the fill. Useful for hiding the fill color while preserving opacity of effects like outline.",
      sliderOptions: {
        min: 0,
        max: 1,
        step: 0.01
      }
    },
    overlayBlur
  ]),
  changeHandler: () => {},
  onInit: (data ) => {
    const selector = roadForm.forms.find(form => form.id === RoadProperties.RoadGroup)
    if (selector) {
      selector.options = generateRoadOptions(data.stringEncodings)
      const intitalOption = selector.options.find(option => option.value === 1)
      if (intitalOption) {
        selector.defaultValue = [intitalOption]
      }
    }
  }
}
